import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import has from 'lodash/has';
import messages from '../../../../../containers/ActForm/messages';

const styles = (theme) => ({
  spacedText: {
    marginRight: theme.spacing(1)
  }
});

function ContextElementsSummary({ contextElements, codes, classes }) {
  return (
    <>
      {contextElements.map((contextElement) => (
        <div key={contextElement} className={classes.spacedText}>
          {has(messages, contextElement) ? <FormattedMessage {...messages[contextElement]} /> : contextElement}
        </div>
      ))}

      {!contextElements.some(
        (contextElement) =>
          contextElement === 'telemedecineParTelephone' || contextElement === 'telemedecineParVisioconsultation'
      ) && codes
        ? codes.map((code) => (
            <div key={code.code} className={classes.spacedText}>
              {code.telemedicineOrRemoteType === 'phone' ? (
                <FormattedMessage {...messages.telemedecineParTelephone} />
              ) : code.telemedicineOrRemoteType === 'visio' ? (
                <FormattedMessage {...messages.telemedecineParVisioconsultation} />
              ) : null}
            </div>
          ))
        : null}
    </>
  );
}

ContextElementsSummary.propTypes = {
  contextElements: PropTypes.array.isRequired,
  codes: PropTypes.array.isRequired
};
export default withStyles(styles)(ContextElementsSummary);
